import { render, staticRenderFns } from "./WorkDetailEvent.vue?vue&type=template&id=677f3da8&scoped=true"
import script from "./WorkDetailEvent.vue?vue&type=script&lang=js"
export * from "./WorkDetailEvent.vue?vue&type=script&lang=js"
import style0 from "./WorkDetailEvent.vue?vue&type=style&index=0&id=677f3da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677f3da8",
  null
  
)

export default component.exports